/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getHospitalProcedures } from 'app/entities/hospital-procedure/hospital-procedure.reducer';
import { getEntities as getTreatmentPlans } from 'app/entities/treatment-plan/treatment-plan.reducer';
import { getEntities as getPrescriptions } from 'app/entities/prescription/prescription.reducer';
import { getEntities as getOpProcedureOrderItems } from 'app/entities/op-procedure-order-item/op-procedure-order-item.reducer';
import { ProcedureStatus } from 'app/shared/model/enumerations/procedure-status.model';
import { ProcedureStatusReason } from 'app/shared/model/enumerations/procedure-status-reason.model';
import { PrescriptionStatus } from 'app/shared/model/enumerations/prescription-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { ProcedureOutcome } from 'app/shared/model/enumerations/procedure-outcome.model';
import { BillOrigin } from 'app/shared/model/enumerations/bill-origin.model';
import { createEntity, getEntity, reset, updateEntity } from './patient-procedure.reducer';

export const PatientProcedureUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const hospitalProcedures = useAppSelector(state => state.hospitalProcedure.entities);
  const treatmentPlans = useAppSelector(state => state.treatmentPlan.entities);
  const prescriptions = useAppSelector(state => state.prescription.entities);
  const opProcedureOrderItems = useAppSelector(state => state.opProcedureOrderItem.entities);
  const patientProcedureEntity = useAppSelector(state => state.patientProcedure.entity);
  const loading = useAppSelector(state => state.patientProcedure.loading);
  const updating = useAppSelector(state => state.patientProcedure.updating);
  const updateSuccess = useAppSelector(state => state.patientProcedure.updateSuccess);
  const procedureStatusValues = Object.keys(ProcedureStatus);
  const procedureStatusReasonValues = Object.keys(ProcedureStatusReason);
  const prescriptionStatusValues = Object.keys(PrescriptionStatus);
  const addedByTypeValues = Object.keys(AddedByType);
  const procedureOutcomeValues = Object.keys(ProcedureOutcome);
  const billOriginValues = Object.keys(BillOrigin);

  const handleClose = () => {
    navigate(`/patient-procedure${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getGlucoUsers({}));
    dispatch(getHospitalProcedures({}));
    dispatch(getTreatmentPlans({}));
    dispatch(getPrescriptions({}));
    dispatch(getOpProcedureOrderItems({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.plannedDate !== undefined && typeof values.plannedDate !== 'number') {
      values.plannedDate = Number(values.plannedDate);
    }
    if (values.performedDate !== undefined && typeof values.performedDate !== 'number') {
      values.performedDate = Number(values.performedDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...patientProcedureEntity,
      ...values,
      surgeon: doctors.find(it => it.id.toString() === values.surgeon?.toString()),
      anaesthesiologist: doctors.find(it => it.id.toString() === values.anaesthesiologist?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      procedure: hospitalProcedures.find(it => it.id.toString() === values.procedure?.toString()),
      treatmentPlan: treatmentPlans.find(it => it.id.toString() === values.treatmentPlan?.toString()),
      prescription: prescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      orderItem: opProcedureOrderItems.find(it => it.id.toString() === values.orderItem?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'PLANNED',
          statusReason: 'SCT_183932001',
          approvedStatus: 'PENDING',
          addedByType: 'DOCTOR',
          outcome: 'SCT_385669000',
          patientType: 'OP',
          ...patientProcedureEntity,
          surgeon: patientProcedureEntity?.surgeon?.id,
          anaesthesiologist: patientProcedureEntity?.anaesthesiologist?.id,
          patient: patientProcedureEntity?.patient?.id,
          procedure: patientProcedureEntity?.procedure?.id,
          treatmentPlan: patientProcedureEntity?.treatmentPlan?.id,
          prescription: patientProcedureEntity?.prescription?.id,
          orderItem: patientProcedureEntity?.orderItem?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientProcedure.home.createOrEditLabel" data-cy="PatientProcedureCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientProcedure.home.createOrEditLabel">Create or edit a PatientProcedure</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-procedure-id"
                  label={translate('tinyMedicRestApp.patientProcedure.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.plannedDate')}
                id="patient-procedure-plannedDate"
                name="plannedDate"
                data-cy="plannedDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.performedDate')}
                id="patient-procedure-performedDate"
                name="performedDate"
                data-cy="performedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.status')}
                id="patient-procedure-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {procedureStatusValues.map(procedureStatus => (
                  <option value={procedureStatus} key={procedureStatus}>
                    {translate(`tinyMedicRestApp.ProcedureStatus.${procedureStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.statusReason')}
                id="patient-procedure-statusReason"
                name="statusReason"
                data-cy="statusReason"
                type="select"
              >
                {procedureStatusReasonValues.map(procedureStatusReason => (
                  <option value={procedureStatusReason} key={procedureStatusReason}>
                    {translate(`tinyMedicRestApp.ProcedureStatusReason.${procedureStatusReason}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.preProcedureNotes')}
                id="patient-procedure-preProcedureNotes"
                name="preProcedureNotes"
                data-cy="preProcedureNotes"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.postProcedureNotes')}
                id="patient-procedure-postProcedureNotes"
                name="postProcedureNotes"
                data-cy="postProcedureNotes"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.active')}
                id="patient-procedure-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.cursor')}
                id="patient-procedure-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.lastupdated')}
                id="patient-procedure-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.microSec')}
                id="patient-procedure-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.timestampentry')}
                id="patient-procedure-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.approved')}
                id="patient-procedure-approved"
                name="approved"
                data-cy="approved"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.approvedStatus')}
                id="patient-procedure-approvedStatus"
                name="approvedStatus"
                data-cy="approvedStatus"
                type="select"
              >
                {prescriptionStatusValues.map(prescriptionStatus => (
                  <option value={prescriptionStatus} key={prescriptionStatus}>
                    {translate(`tinyMedicRestApp.PrescriptionStatus.${prescriptionStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.addedByType')}
                id="patient-procedure-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.addedById')}
                id="patient-procedure-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.outcome')}
                id="patient-procedure-outcome"
                name="outcome"
                data-cy="outcome"
                type="select"
              >
                {procedureOutcomeValues.map(procedureOutcome => (
                  <option value={procedureOutcome} key={procedureOutcome}>
                    {translate(`tinyMedicRestApp.ProcedureOutcome.${procedureOutcome}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedure.patientType')}
                id="patient-procedure-patientType"
                name="patientType"
                data-cy="patientType"
                type="select"
              >
                {billOriginValues.map(billOrigin => (
                  <option value={billOrigin} key={billOrigin}>
                    {translate(`tinyMedicRestApp.BillOrigin.${billOrigin}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-surgeon"
                name="surgeon"
                data-cy="surgeon"
                label={translate('tinyMedicRestApp.patientProcedure.surgeon')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-anaesthesiologist"
                name="anaesthesiologist"
                data-cy="anaesthesiologist"
                label={translate('tinyMedicRestApp.patientProcedure.anaesthesiologist')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.patientProcedure.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="patient-procedure-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.patientProcedure.procedure')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitalProcedures
                  ? hospitalProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="patient-procedure-treatmentPlan"
                name="treatmentPlan"
                data-cy="treatmentPlan"
                label={translate('tinyMedicRestApp.patientProcedure.treatmentPlan')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentPlans
                  ? treatmentPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.patientProcedure.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {prescriptions
                  ? prescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-orderItem"
                name="orderItem"
                data-cy="orderItem"
                label={translate('tinyMedicRestApp.patientProcedure.orderItem')}
                type="select"
              >
                <option value="" key="0" />
                {opProcedureOrderItems
                  ? opProcedureOrderItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-procedure" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientProcedureUpdate;
